/**
 * Output Downscaled Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const OUTPUT_DOWNSCALED = 'output-downscaled';
